export const LOAD_INSTRUMENT_LIST = 'LOAD_INSTRUMENT_LIST';
export const LOAD_INSTRUMENT_LIST_SUCCESS = 'LOAD_INSTRUMENT_LIST_SUCCESS';
export const LOAD_INSTRUMENT_LIST_FAILURE = 'LOAD_INSTRUMENT_LIST_FAILURE';
export const CLOSE_SOCKET_DATA = 'CLOSE_SOCKET_DATA';
export const UPDATE_SOCKET_DATA = 'UPDATE_SOCKET_DATA';
export const LOAD_SOCKET_DATA = 'LOAD_SOCKET_DATA';
export const SUBSCRIBE_TIER='SUBSCRIBE_TIER';
export const UNSUBSCRIBE_TIER='UNSUBSCRIBE_TIER';
export const UPDATE_STATUS ='UPDATE_STATUS';
export const SUCCESS_DEFAULT = 'SUCCESS_DEFAULT';
export const FAILURE_DEFAULT = 'FAILURE_DEFAULT';
export const LOAD_MARGINCOMPONENT = 'LOAD_MARGINCOMPONENT';
export const UPDATE_MARGINDATA = 'UPDATE_MARGINDATA';
export const LOAD_MARGINDATA = 'LOAD_MARGINDATA';
export const LOAD_ACCBAL='LOAD_ACCBAL';
export const UPDATE_ACCBAL='UPDATE_ACCBAL';
export const UPDATE_INST='UPDATE_INST';
export const UPDATE_MARGIN_PERC='UPDATE_MARGIN_PERC';
export const LOAD_ACCOUNT='LOAD_ACCOUNT';
export const LOAD_ACCOUNT_SUCCESS='LOAD_ACCOUNT_SUCCESS';
export const LOAD_ACCOUNT_FAILURE='LOAD_ACCOUNT_FAILURE';
export const SOCKET_FLAG='SOCKET_FLAG';
export const UPDATE_VALUEDATE='UPDATE_VALUEDATE';
export const RESET_STATE_SOCKET = 'RESET_STATE_SOCKET';
export const RESET_SOCKET_DATA = 'RESET_SOCKET_DATA';
export const REFRESH_PROXIMITY='REFRESH_PROXIMITY';
export const SUBSCRIBE_FWD_RATES = "SUBSCRIBE_FWD_RATES";
export const UNSUBSCRIBE_FWD_RATES = "UNSUBSCRIBE_FWD_RATES";
export const UPDATE_FORWARDS_DATA = "UPDATE_FORWARDS_DATA";
export const GET_VAL_DATE ="GET_VAL_DATE";
export const GET_VAL_DATE_SUCCESS ="GET_VAL_DATE_SUCCESS";
export const GET_VAL_DATE_FAILURE ="GET_VAL_DATE_FAILURE";
export const SET_NEW_KEY="SET_NEW_KEY";